import React, { memo, FC } from 'react';

import ElementTag, { ElementTagProps } from '../internal/ElementTag';

const Container: FC<ContainerProps> = ({ children, ...rest }) => (
  <ElementTag {...rest}>{children}</ElementTag>
);

export type ContainerProps = ElementTagProps;

export default memo(Container);
